import { __decorate } from "tslib";
import { AnyDecoder, ArrayDecoder, AutoEncoder, BooleanDecoder, field, IntegerDecoder, RecordDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { Formatter } from '@stamhoofd/utility';
import { PaymentMethod, PaymentMethodHelper } from './PaymentMethod.js';
export class Requirements extends AutoEncoder {
    currently_due = [];
    eventually_due = [];
    past_due = [];
    current_deadline = null;
    disabled_reason = null;
}
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), optional: true })
], Requirements.prototype, "currently_due", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), optional: true })
], Requirements.prototype, "eventually_due", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), optional: true })
], Requirements.prototype, "past_due", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true, nullable: true })
], Requirements.prototype, "current_deadline", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], Requirements.prototype, "disabled_reason", void 0);
export class StripeBusinessProfile extends AutoEncoder {
    mcc = null;
    name = '';
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], StripeBusinessProfile.prototype, "mcc", void 0);
__decorate([
    field({ decoder: StringDecoder })
], StripeBusinessProfile.prototype, "name", void 0);
export class StripeCompany extends AutoEncoder {
    name = null;
    structure = null;
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], StripeCompany.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], StripeCompany.prototype, "structure", void 0);
export class StripeMetaAccountDashboardSettings extends AutoEncoder {
    display_name = '';
}
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StripeMetaAccountDashboardSettings.prototype, "display_name", void 0);
export class StripeMetaAccountSettings extends AutoEncoder {
    dashboard = StripeMetaAccountDashboardSettings.create({});
}
__decorate([
    field({ decoder: StripeMetaAccountDashboardSettings, optional: true })
], StripeMetaAccountSettings.prototype, "dashboard", void 0);
export class StripeMetaData extends AutoEncoder {
    type = 'express';
    blob = null;
    business_profile = StripeBusinessProfile.create({});
    business_type = null;
    company = null;
    charges_enabled = false;
    payouts_enabled = false;
    details_submitted = false;
    capabilities = {};
    requirements = Requirements.create({});
    settings = StripeMetaAccountSettings.create({});
    future_requirements = Requirements.create({});
    bank_account_last4 = '';
    bank_account_bank_name = '';
    bank_account_name = '';
    get paymentMethods() {
        if (!this.charges_enabled) {
            return [];
        }
        const methods = [];
        if (this.capabilities.card_payments === 'active') {
            methods.push(PaymentMethod.CreditCard);
        }
        if (this.capabilities.bancontact_payments === 'active') {
            methods.push(PaymentMethod.Bancontact);
        }
        if (this.capabilities.ideal_payments === 'active') {
            methods.push(PaymentMethod.iDEAL);
        }
        if (this.capabilities.sepa_debit_payments === 'active') {
            methods.push(PaymentMethod.DirectDebit);
        }
        return methods;
    }
}
__decorate([
    field({ decoder: StringDecoder, optional: true })
], StripeMetaData.prototype, "type", void 0);
__decorate([
    field({ decoder: AnyDecoder, optional: true, nullable: true })
], StripeMetaData.prototype, "blob", void 0);
__decorate([
    field({ decoder: StripeBusinessProfile, optional: true })
], StripeMetaData.prototype, "business_profile", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StripeMetaData.prototype, "business_type", void 0);
__decorate([
    field({ decoder: StripeCompany, optional: true, nullable: true })
], StripeMetaData.prototype, "company", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], StripeMetaData.prototype, "charges_enabled", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], StripeMetaData.prototype, "payouts_enabled", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], StripeMetaData.prototype, "details_submitted", void 0);
__decorate([
    field({ decoder: new RecordDecoder(StringDecoder, StringDecoder), optional: true })
], StripeMetaData.prototype, "capabilities", void 0);
__decorate([
    field({ decoder: Requirements, optional: true })
], StripeMetaData.prototype, "requirements", void 0);
__decorate([
    field({ decoder: StripeMetaAccountSettings, optional: true })
], StripeMetaData.prototype, "settings", void 0);
__decorate([
    field({ decoder: Requirements, optional: true })
], StripeMetaData.prototype, "future_requirements", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], StripeMetaData.prototype, "bank_account_last4", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], StripeMetaData.prototype, "bank_account_bank_name", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], StripeMetaData.prototype, "bank_account_name", void 0);
function requirementsToString(list) {
    let missing = list.map((key) => {
        if (key.match(/person_.+?\.verification.document/)) {
            return $t(`%nL`);
        }
        if (key.match(/(?:representative|person|individual|director)\.address/)) {
            return $t(`%nM`);
        }
        if (key.match(/(?:representative|person|individual|director)\.phone/)) {
            return $t(`%nN`);
        }
        if (key.match(/(?:representative|person|individual|director)\.email/)) {
            return $t(`%nO`);
        }
        if (key.match(/(?:representative|person|individual|director)\.dob/)) {
            return $t(`%nP`);
        }
        if (key.match(/(?:representative|person|individual|director)\.(?:first|last)_name/)) {
            return $t(`%nQ`);
        }
        if (key.match(/(?:representative|person|individual|director)?\.relationship.title/)) {
            return $t(`%nR`);
        }
        if (key.match(/person_.+?\.address/)) {
            return $t(`%nS`);
        }
        if (key.match(/person_.+?\.phone/)) {
            return $t(`%nT`);
        }
        if (key.match(/person_.+?\.email/)) {
            return $t(`%nU`);
        }
        if (key.match(/person_.+?\.dob/)) {
            return $t(`%nV`);
        }
        if (key.match(/person_.+?\.(?:first|last)_name/)) {
            return $t(`%nW`);
        }
        if (key.match(/person_.+?\.relationship.title/)) {
            return $t(`%nX`);
        }
        if (key.match(/(?:representative|person|individual|director)_/)) {
            return $t(`%nY`);
        }
        if (key.match(/company_.+?\.address/)) {
            return $t(`%nZ`);
        }
        if (key === 'company.phone') {
            return $t(`%na`);
        }
        if (key === 'company.name') {
            return $t(`%nb`);
        }
        if (key === 'company.verification.document') {
            return $t(`%nc`);
        }
        if (key === 'individual.verification.document') {
            return $t(`%nd`);
        }
        if (key === 'business_profile.product_description') {
            return $t(`%ne`);
        }
        if (key === 'business_profile.url') {
            return $t(`%nf`);
        }
        return $t(`%tu`);
    });
    missing = Formatter.uniqueArray(missing);
    return Formatter.joinLast(missing, ', ', ' ' + $t(`%M1`) + ' ');
}
export class StripeAccountPatch extends AutoEncoder {
    businessProfileUrl = null;
    businessProfileName = null;
}
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StripeAccountPatch.prototype, "businessProfileUrl", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StripeAccountPatch.prototype, "businessProfileName", void 0);
export class StripeAccount extends AutoEncoder {
    id;
    accountId;
    meta;
    get missingData() {
        return requirementsToString([...this.meta.requirements.past_due, ...this.meta.future_requirements.past_due, ...this.meta.requirements.currently_due, ...this.meta.requirements.eventually_due, ...this.meta.future_requirements.currently_due, ...this.meta.future_requirements.eventually_due]);
    }
    get canDelete() {
        return !this.meta.charges_enabled || !this.meta.payouts_enabled || !this.meta.details_submitted;
    }
    get warning() {
        if (this.meta.requirements.current_deadline) {
            const missing = this.missingData;
            return {
                text: $t(`%ng`, { date: Formatter.date(new Date(this.meta.requirements.current_deadline * 1000)) }) + ' ' + missing + '.',
                type: 'error',
            };
        }
        if (this.meta.charges_enabled && this.meta.paymentMethods.length < 3) {
            const missing = [PaymentMethod.CreditCard, PaymentMethod.Bancontact, PaymentMethod.iDEAL].filter(m => !this.meta.paymentMethods.includes(m));
            const text = Formatter.joinLast(missing.map(m => PaymentMethodHelper.getName(m)), ', ', ' ' + $t(`%M1`) + ' ');
            const missingText = this.missingData;
            if (missing.length === 1) {
                return {
                    text: $t(`%nh`, { method: text }) + ' ' + (missingText ? (' ' + $t(`Volgende zaken zouden ontbreken:`) + ' ' + missingText + '.') : ''),
                    type: 'error',
                };
            }
            return {
                text: $t(`%ni`, { methods: text }) + ' ' + (missingText ? (' ' + $t(`Volgende zaken zouden ontbreken:`) + ' ' + missingText + '.') : ''),
                type: 'error',
            };
        }
        if (this.meta.future_requirements.current_deadline) {
            const missing = this.missingData;
            const d = new Date(this.meta.future_requirements.current_deadline * 1000);
            return {
                text: $t(`%ng`, { date: Formatter.date(d) }) + ' ' + missing + '.',
                // Error if needed within one month
                type: d < new Date(Date.now() + 24 * 60 * 60 * 1000 * 30) ? 'error' : 'warning',
            };
        }
        if (this.meta.details_submitted && (this.meta.requirements.currently_due.length || this.meta.requirements.eventually_due.length || this.meta.future_requirements.currently_due.length || this.meta.future_requirements.eventually_due.length)) {
            // Try to convert to readable text
            const missing = this.missingData;
            return {
                text: $t(`%nj`) + ' ' + missing + '.',
                type: 'warning',
            };
        }
    }
}
__decorate([
    field({ decoder: StringDecoder })
], StripeAccount.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], StripeAccount.prototype, "accountId", void 0);
__decorate([
    field({ decoder: StripeMetaData })
], StripeAccount.prototype, "meta", void 0);
//# sourceMappingURL=StripeAccount.js.map